export const LocaleFormat = {
  PHONE_NUMBER_PREFIX_VI: '+84',
  PHONE_NUMBER_PREFIX_US: '+1',
  PHONE_NUMBER_LENGTH_MAX: 10,
  PHONE_NUMBER_LENGTH_MIN: 10,
  REGION_US: 'us',
  REGION_VI: 'vi'
}
